import { AIHandoff } from '../types';

const STORAGE_KEY = 'ai-alerts-enabled';
let audioContext: AudioContext | null = null;

const notificationSupported = () =>
  typeof window !== 'undefined' && 'Notification' in window;

const getAudioContext = () => {
  if (audioContext || typeof window === 'undefined') return audioContext;
  const AudioContextConstructor = (
    window as typeof window & {
      webkitAudioContext?: typeof AudioContext;
    }
  ).AudioContext ||
    (
      window as typeof window & {
        webkitAudioContext?: typeof AudioContext;
      }
    ).webkitAudioContext;
  if (!AudioContextConstructor) return null;
  try {
    audioContext = new AudioContextConstructor();
  } catch {
    audioContext = null;
  }
  return audioContext;
};

export const browserAlertsEnabled = () => {
  if (!notificationSupported()) return false;
  return (
    window.localStorage.getItem(STORAGE_KEY) === '1' &&
    window.Notification.permission === 'granted'
  );
};

export const enableBrowserAlerts = async () => {
  if (!notificationSupported()) return false;
  try {
    const permission = await window.Notification.requestPermission();
    if (permission !== 'granted') {
      window.localStorage.removeItem(STORAGE_KEY);
      return false;
    }
    window.localStorage.setItem(STORAGE_KEY, '1');
    const context = getAudioContext();
    if (context?.state === 'suspended') await context.resume();
    return true;
  } catch {
    return false;
  }
};

const playTone = () => {
  const context = getAudioContext();
  if (!context) return;
  try {
    const oscillator = context.createOscillator();
    oscillator.type = 'sine';
    oscillator.frequency.value = 740;
    oscillator.connect(context.destination);
    oscillator.start();
    oscillator.stop(context.currentTime + 0.15);
  } catch {
    // Browser notifications remain useful when audio is unavailable.
  }
};

export const notifyAIAlert = (alert: AIHandoff) => {
  if (!browserAlertsEnabled()) return;
  try {
    new window.Notification('AI 接待需要处理', {
      body: alert.reason_text.slice(0, 120),
      tag: `ai-alert-${alert.id}`,
    });
    playTone();
  } catch {
    // Notification delivery is best-effort and never interrupts the dashboard.
  }
};
